import { beforeEnterBimex } from "@/CommonDP/router/method/method";
import knowledge from './modules/knowledge';
import { application } from './modules/application';
import { planApprovalPoints, settings } from './modules/settings';
import { mongeView } from './modules/mongeView';

export const routeCustomizeFunc = (routerConfig) => {
   //添加bim4D的预览
   routerConfig.routes.push({
    path: '/bimPreview',
    name: 'bimPreview',
    beforeEnter: beforeEnterBimex,
    component: () => import('@/views/project/engManage/bimPreview.vue'),
    meta: {
      routeName: '预览',
    },
  });

  
  // 实现对路由的自定义处理
  const flatList = [...routerConfig.routes];
  const routerMap = {};
  for (const route of flatList) {
    routerMap[route.name] = route;
    if (route?.children) {
      flatList.push(...route.children);
    }
  }
  console.log(routerMap);
  //修改登录页
  routerMap.login.component = () => import('@/views/login/login.vue');

  //修改注册页
  routerMap.register.component = () => import ("@/views/register")
  //修改工作台地址
  routerMap.Work.component = () =>
    import('@/views/workbench/index.vue');
    const { Work } = routerMap;
  Work.meta.hideSubMenu=true;
  Work.meta.prouteName="工作台";
  Work.meta.pname="工作台";

  // 替换知识->个人
  Object.assign(routerMap.doc, knowledge);
  // 替换应用->立项
  Object.assign(routerMap.application, application);

  // 设置添加路由：审图要点
  routerMap.settings.children.push(planApprovalPoints);

  // 向 project 路由children 添加路由首页
  routerMap.project.children.push({
    path: '/project-home',
    name: 'projectHome',
    component: () => import('@/views/project/home/home.vue'),
    meta: {
      routeName: '首页',
      prouteName: '首页',
      pname: '项目',
      icon1: require('@/views/assets/settings/allNews1.png'),
      icon2: require('@/views/assets/settings/allNews2.png'),
    },
  },
  {
    path: '/project-engManage',
    name: 'projectEngManage',
    component: () => import('@/views/project/engManage/index.vue'),
    meta: {
      routeName: '工程管理',
      prouteName: '工程管理',
      pname: '项目',
      icon1: require('@/views/assets/settings/notice1.png'),
      icon2: require('@/views/assets/settings/notice2.png'),
    },
    children:[
      {
        path: '/project-buildPlan',
        name: 'projectBuildPlan',
        component: () => import('@/views/project/engManage/buildPlan.vue'),
        meta: {
          routeName: '计划',
          prouteName: '计划',
          pname: '项目',
          icon1: require('@/views/assets/settings/taskNews1.png'),
          icon2: require('@/views/assets/settings/taskNews2.png'),
        }
      },
      {
        path: '/project-bimManage',
        name: 'projectBimManage',
        beforeEnter: beforeEnterBimex,
        component: () => import('@/views/project/engManage/bimManage.vue'),
        meta: {
          routeName: 'BIM管理',
          prouteName: '计划',
          pname: '项目',
          icon1: require('@/views/assets/settings/notice1.png'),
          icon2: require('@/views/assets/settings/notice2.png'),
        }
      },
      {
        path: '/project-bimFour',
        name: 'projectBimFour',
        component: () => import('@/views/project/engManage/bimFour.vue'),
        meta: {
          routeName: 'BIM4D',
          prouteName: '计划',
          pname: '项目',
          icon1: require('@/views/assets/settings/notice1.png'),
          icon2: require('@/views/assets/settings/notice2.png'),
        }
      },
      //新增任务
      {
        path: '/project-buildTask',
        name: 'buildTask',
        component: () => import('@/views/project/task/list.vue'),
        meta: {
          routeName: '施工计划',
          prouteName: '计划',
          pname: '项目',
          permissionKey: 'projectBuildPlan',
        },
      },
      {
        path: '/project-buildTaskDeatail',
        name: 'buildTaskDeatail',
        component: () => import('@/views/project/task/taskDetail.vue'),
        meta: {
          routeName: '施工计划',
          prouteName: '计划',
          pname: '项目',
          permissionKey: 'projectBuildPlan',
        },
        props: (route) => ({
          task: route.query.task,
          showType: route.query.showType,
          conPlanId:route.query.conPlanId
        }),
      },
      //编辑任务
      {
        path: '/project-editDetail',
        name: 'editTaskDetail',
        component: () => import('@/views/project/task/editTaskDetail.vue'),
        meta: {
          routeName: '施工计划',
          prouteName: '计划',
          pname: '项目',
          permissionKey: 'projectBuildPlan',
        },
        props: (route) => ({
          task: route.query.task,
          showType: route.query.showType,
          conPlanId:route.query.conPlanId
        }),
      },
      //质量管理
      {
        path: '/project-quaMange',
        name: 'projectDuaMange',
        component: () => import('@/views/project/quaMange'),
        meta: {
          routeName: '质量管理',
          prouteName: '计划',
          pname: '项目',
        }
      },
      //安全管理
      {
        path: '/project-safeMange',
        name: 'projectSafeMange',
        component: () => import('@/views/project/safeMange'),
        meta: {
          routeName: '安全管理',
          prouteName: '计划',
          pname: '项目',
        }
      },
    ]
  });
  //修改问题
  routerMap.issueMg.component = () =>
    import('@/views/project/issueMg/issueMg.vue');

  //修改立项
  routerMap.createProjectAddEdit.component = () =>
    import('@/views/project/createProject');

  //修改消息
  routerMap.proMessage.component = () =>
    import('@/views/message/message');
  routerMap.otherMessage.component = () =>
    import('@/views/message/message');
  routerMap.taskMessage.component = () =>
    import('@/views/message/message');
  routerMap.allMessage.component = () =>
    import('@/views/message/message');
  routerMap.annotationMessage.component = () =>
    import('@/views/message/message');

  //将人员管理修改为内部人员
  routerMap.personInfo.component = () =>
    import('@/views/personManage/index.vue');
  const { personInfo } = routerMap;
  personInfo.meta.prouteName="内部人员";
  personInfo.meta.routeName="内部人员"

  //修改添加成员
  routerMap.addpersonInfo.component = () =>
    import('@/views/personManage/addPerson.vue');
  
 //修改更多人员
  routerMap.morepersonInfo.component = () =>
     import('@/views/personManage/moreperson.vue');


  
  //修改权限管理
  routerMap.rolePowerConfig.component = () =>
    import('@/views/perman/index');

  // 向 设置 路由children 添加成员管理
  routerMap.settings.children.push({
    path: '/supperManage',
    name: 'supperManage',
    component: () => import('@/views/supperson/index.vue'),
    meta: {
      routeName: '账户管理',
      prouteName: '账户管理',
      pname: '设置',
      icon1: require("@/CommonDP/assets/settings/userCount1.png"),
      icon2: require("@/CommonDP/assets/settings/userCount2.png"),
    },
  });

//修改成员
routerMap.personPlan.component = () =>
  import('@/views/project/prjMember/prjMember.vue');

//修改邀请人员
routerMap.invitePersonPlan.component = () =>
  import('@/views/project/prjMember/invitePersonPlan.vue');

 //修改策划
 routerMap.setup.component = () =>
  import('@/views/project/plan/plan.vue');

 routerMap.rolePermission.component = () =>
  import('@/views/project/plan/components/rolePermission');
  routerMap.appViewOffice.component = () => import('@/views/docFilePreview/office');
  routerMap.appViewPdf.component = () => import('@/views/docFilePreview/pdf');
  // 文件预览-批注定制
  mongeView(routerMap);

  // 设置
  settings(routerMap)

  return routerConfig;
}
